const en = {
  nav: {
    home: "Home",
    register: "Register",
    login: "Login",
    support: "Support",
    logout: "Logout",
    pricing: "Pricing",
  },
  home: {
    hero_tag: "For Azerbaijani Citizens",
    hero_title: "Secure Email Service",
    hero_subtitle: "FIN-verified accounts. Data security compliant with government standards.",
    hero_cta: "Register Now",
    hero_login: "Login",
    features_title: "Why Mail.net.az?",
    features_subtitle: "Built by Azerbaijanis for Azerbaijanis",
    feature1_title: "FIN-Based Verification",
    feature1_desc: "Exclusively for Azerbaijani citizens. Fully verified accounts with ID card FIN code.",
    feature2_title: "99.9% Uptime",
    feature2_desc: "Server infrastructure compliant with government standards. 24/7 monitoring and uninterrupted service.",
    feature3_title: "End-to-End Encryption",
    feature3_desc: "All your emails are protected with AES-256 encryption. Full privacy guarantee.",
    feature4_title: "Multilingual Interface",
    feature4_desc: "AZ, RU, EN language support. Comfortable and familiar user interface.",
    stats_label: "Mail.net.az in Numbers",
    stats_desc: "Azerbaijan\'s most trusted email hosting platform. Thousands of citizens already trust Mail.net.az.",
    stat1_num: "25,000+",
    stat1_label: "Active Users",
    stat2_num: "99.9%",
    stat2_label: "Server Uptime",
    stat3_num: "24/7",
    stat3_label: "Technical Support",
    stat4_num: "100%",
    stat4_label: "AZ Citizens",
    reviews_title: "What Our Citizens Say",
    reviews_label: "User Reviews",
    cta_title: "Create Your Secure Email Account Now",
    cta_subtitle: "5-minute registration. Fully functional account with FIN verification.",
    cta_btn: "Start Registration",
  },
  register: {
    title: "Create New Account",
    subtitle: "Exclusive for Azerbaijani Citizens",
    firstname: "First Name",
    lastname: "Last Name",
    email: "Email Address",
    email_placeholder: "firstname.lastname@mail.net.az",
    fin: "FIN Number",
    fin_placeholder: "7-digit FIN code",
    id_serial: "ID Serial",
    id_serial_placeholder: "AZE",
    id_number: "ID Number",
    id_number_placeholder: "00000000",
    phone: "Phone Number",
    phone_placeholder: "+994 50 000 00 00",
    password: "Password",
    password_placeholder: "Minimum 8 characters",
    confirm_password: "Confirm Password",
    confirm_password_placeholder: "Re-enter password",
    terms: "I accept the terms of service",
    terms_link: "Terms",
    btn: "Complete Registration",
    already: "Already have an account?",
    login_link: "Login",
    feature1: "Full FIN-based verification",
    feature2: "Government standards",
    feature3: "Full privacy guarantee",
    fin_info: "Your FIN can be found on your identity card",
    success: "Your registration request has been accepted!",
    success_msg: "A notification will be sent to your email address shortly.",
    error_fin: "FIN must be 7 digits",
    error_password: "Passwords do not match",
    error_terms: "You must accept the terms",
  },
  login: {
    title: "Sign In to Your Account",
    subtitle: "Welcome to Mail.net.az Portal",
    email: "Email Address",
    email_placeholder: "firstname.lastname@mail.net.az",
    password: "Password",
    password_placeholder: "Enter your password",
    remember: "Remember me",
    forgot: "Forgot password?",
    btn: "Login",
    fin_btn: "Login with FIN",
    or: "or",
    no_account: "Don\'t have an account?",
    register_link: "Register",
    secure: "SSL encrypted secure connection",
    fin_modal_title: "Login with FIN",
    fin_modal_desc: "Enter your FIN number and password",
    fin_modal_fin: "FIN Number",
    fin_modal_pass: "Password",
    fin_modal_btn: "Confirm",
    fin_modal_close: "Close",
  },
  support: {
    hero_title: "How Can We Help You?",
    hero_placeholder: "Type your question...",
    contact1_title: "Phone Support",
    contact1_num: "+994 12 000 00 00",
    contact1_hours: "Mon-Fri 09:00 - 18:00",
    contact2_title: "Email Support",
    contact2_addr: "support@mail.net.az",
    contact2_time: "Response within 24 hours",
    contact3_title: "Live Chat",
    contact3_btn: "Start Now",
    contact3_status: "Currently active",
    faq_title: "Frequently Asked Questions",
    faq_subtitle: "Answers to the most asked questions",
    form_title: "Write to Us",
    form_name: "Full Name",
    form_email: "Email",
    form_subject: "Subject",
    form_message: "Your Message",
    form_btn: "Send",
    form_success: "Your message has been sent! We will reply shortly.",
    office_title: "Office Information",
    office_addr: "Baku, Narimanov dist., Ahmad Javad st. 20",
    office_hours: "Mon-Fri: 09:00 - 18:00",
    office_weekend: "Saturday: 10:00 - 15:00",
  },
  pricing: {
    hero_tag: "Transparent Pricing",
    hero_title: "Choose Your Plan",
    hero_subtitle: "All plans include FIN verification and government-standard security.",
    monthly: "Monthly",
    annual: "Annual",
    annual_badge: "2 months free",
    popular: "Most Popular",
    plan1_name: "Personal",
    plan1_desc: "Ideal starter package for individual users",
    plan1_price_monthly: "Free",
    plan1_price_annual: "Free",
    plan2_name: "Business",
    plan2_desc: "Powerful solution for small and medium businesses",
    plan2_price_monthly: "₼15",
    plan2_price_annual: "₼12",
    plan3_name: "Corporate",
    plan3_desc: "Full-featured package for large organizations",
    plan3_price_monthly: "₼49",
    plan3_price_annual: "₼39",
    per_month: "/mo",
    get_started: "Get Started",
    contact_sales: "Contact Sales",
    current_plan: "Current Plan",
    feature_table_title: "Plan Comparison",
    feature_table_subtitle: "Compare features included in each plan",
    cta_title: "Still Not Sure?",
    cta_subtitle: "Discuss your business needs with us — we\'ll find the right plan together.",
    cta_btn: "Talk to an Expert",
    month_short: "mo",
  },
  footer: {
    desc: "Mail.net.az — Secure FIN-based email hosting service for Azerbaijani citizens.",
    services: "SERVICES",
    email_hosting: "Email Hosting",
    domain: "Domain Registration",
    ssl: "SSL Certificate",
    help: "SUPPORT",
    faq: "FAQ",
    contact: "Contact",
    docs: "Documentation",
    legal: "LEGAL",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    gdpr: "GDPR",
    copyright: "© 2025 Mail.net.az. All rights reserved.",
  },
};

export default en;
